import {
  play,
  pause,
} from "../../components/BackgroundVideo/initBackgroundVideo.js";

function pauseVideos(root) {
  // Pause Sitecore videos
  root.querySelectorAll(".js-background-video").forEach((el) => {
    const buttonEl = el.querySelector(".js-background-video-button");
    const videoEl = el.querySelector(".js-background-video-media");
    pause({ buttonEl, videoEl });
  });

  // Pause YouTube videos
  root.querySelectorAll(".js-youtube-video-mount iframe").forEach((iframe) => {
    iframe.contentWindow.postMessage(
      '{"event":"command","func":"pauseVideo","args":""}',
      "https://www.youtube-nocookie.com",
    );
  });
}

/**
 * @param {HTMLElement} wrapper
 * @param {"sitecore" | "youtube"} platform
 */
function playVideo(wrapper, platform) {
  if (platform === "youtube") {
    const youtubeAppRoot = wrapper.querySelector(".youtube-video");
    const id = youtubeAppRoot.id;
    if (!id) return;

    const event = new CustomEvent("half-gate-hero-modal-open", {
      detail: {
        id,
      },
    });
    window.dispatchEvent(event);
  } else {
    const el = wrapper.querySelector(".js-background-video");
    const buttonEl = el.querySelector(".js-background-video-button");
    const videoEl = el.querySelector(".js-background-video-media");

    play({ el, buttonEl, videoEl });
  }
}

function initLinkVideo(root) {
  if (document.body.classList.contains("is-page-editor")) return;

  const links = [...root.querySelectorAll(".js-half-gate-hero-link-video")];
  const modal = root.querySelector(".js-half-gate-hero-modal");

  if (links.length === 0 || !modal) return;

  const closeButton = modal.querySelector(".js-half-gate-hero-close-button");

  // show the modal
  links.forEach((link) => {
    link.addEventListener("click", (event) => {
      modal.showModal();
      modal.addEventListener(
        "animationend",
        (event) => {
          if (event.animationName === "modal-fade-in") {
            const isMobile = window.matchMedia("(max-width: 680px)").matches;
            const desktopVideoWrapper = modal.querySelector(
              ".half-gate-hero__video-wrapper--desktop",
            );
            const mobileVideoWrapper = modal.querySelector(
              ".half-gate-hero__video-wrapper--mobile",
            );
            let video;

            if (isMobile) {
              video = mobileVideoWrapper || desktopVideoWrapper;
            } else {
              video = desktopVideoWrapper;
            }

            if (!video) return;

            playVideo(video, video.dataset.platform);

            closeButton.focus();
          }
        },
        { once: true },
      );
    });
  });

  // listen for close event (esc key)
  modal.addEventListener("close", (event) => {
    pauseVideos(modal);

    const isMobile = window.matchMedia("(max-width: 680px)").matches;

    const mobileLink = links.find((link) =>
      link.classList.contains("half-gate-hero__link--mobile"),
    );
    const desktopLink = links.find((link) =>
      link.classList.contains("half-gate-hero__link--desktop"),
    );
    const targetLink = isMobile ? mobileLink || desktopLink : desktopLink;

    targetLink.focus();
  });

  // init close button
  closeButton.addEventListener("click", (event) => {
    modal.close();
  });

  // add clickaway
  modal.addEventListener("click", (event) => {
    if (event.target === event.currentTarget) {
      modal.close();
    }
  });

  // if mobile + desktop video, close modal on breakpoint switch
  if (links.length > 1) {
    const mediaQuery = window.matchMedia("(max-width: 680px)");
    mediaQuery.addEventListener("change", () => modal.close());
  }
}

export default () => {
  document.querySelectorAll(".js-half-gate-hero").forEach((el) => {
    initLinkVideo(el);
  });
};
